import { ParseKeys } from "i18next";

import { nameof } from "../../../../utils/nameof";
import { DescribeMissingField, itemFieldPath, requiredMessage } from "../../utils/missingFields.utils";
import { AssetIncomeFormValues, IncomeEntryFormValue, IncomeMonthFormValue } from "./IncomeView.types";

const INCOMES = nameof<AssetIncomeFormValues>("incomes");
const PAYER = nameof<IncomeEntryFormValue>("payerNameAndAddress");
const MONTH_FIELD = /^months\[\d+\]\.(\w+)$/;

const MONTH_LABELS: Record<keyof IncomeMonthFormValue, ParseKeys> = {
  month: "clients.client.debtSettlement.assetInventory.incomeTab.months.month",
  paidAmount: "clients.client.debtSettlement.assetInventory.incomeTab.months.paidAmount",
  garnishedAmount: "clients.client.debtSettlement.assetInventory.incomeTab.months.garnishedAmount",
  expenseAllowance: "clients.client.debtSettlement.assetInventory.incomeTab.months.expenseAllowance",
  familyAllowance: "clients.client.debtSettlement.assetInventory.incomeTab.months.familyAllowance",
  employerSettledExpenses: "clients.client.debtSettlement.assetInventory.incomeTab.months.employerSettledExpenses",
  specialPaymentPaid: "clients.client.debtSettlement.assetInventory.incomeTab.months.specialPaymentPaid",
};

function monthLabelOf(field: string): ParseKeys | undefined {
  const monthField = MONTH_FIELD.exec(field)?.[1];
  return monthField && monthField in MONTH_LABELS ? MONTH_LABELS[monthField as keyof IncomeMonthFormValue] : undefined;
}

export const describeMissingIncomeField: DescribeMissingField<AssetIncomeFormValues> = (missing, values, t) => {
  if (missing.itemId === null) {
    return { path: missing.field };
  }

  const path = itemFieldPath(INCOMES, values.incomes, missing);
  if (!path) {
    return undefined;
  }

  if (missing.field === PAYER) {
    return { path, message: t("clients.client.debtSettlement.assetInventory.incomeTab.validation.payerIncomplete") };
  }

  const monthLabel = monthLabelOf(missing.field);
  return monthLabel ? { path, message: requiredMessage(t, monthLabel) } : { path };
};
